import React, {useState} from 'react';
import {
    List,
    Typography,
    withStyles,
    Box,
    IconButton,
    Button
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import styles from './styles';
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import TourStopCard from "../TourStopCard";

function DriverTourDetail(props) {
    const {classes, t, tour, saveEditedStopProducts, boxTypesAllShipper, onBack} = props;
    
    const sortedStops = [...tour.stops].sort((a, b) => (a.stopNumber || 0) - (b.stopNumber || 0));
    const [editedStops, setEditedStops] = useState({});

    const handleAmountChange = (stopId, boxTypeId, newValue) => {
        setEditedStops(prevState => ({
            ...prevState,
            [stopId]: {
                ...prevState[stopId],
                [boxTypeId]: newValue
            }
        }));
    };

    const handleSave = () => {
        const modifiedStopsPayload = Object.keys(editedStops).map(stopIdString => {
            const stopId = Number(stopIdString);
            const originalStop = tour.stops.find(s => s.tourStopId === stopId);
            const boxTypes = boxTypesAllShipper[originalStop.shipperName] || [];

            const allProductsForStop = boxTypes.map(boxType => {
                const editedValue = editedStops[stopId][boxType.boxTypeId];
                const isEdited = editedValue !== undefined;

                const existingProduct = originalStop.products?.find(
                    p => p.boxType === boxType.identifier
                );
                const initialValue = existingProduct ? existingProduct.amount : 0;

                return {
                    boxType: boxType.identifier,
                    amount: isEdited ? editedValue : initialValue,
                };
            });

            return {
                tourStopId: stopId,
                products: allProductsForStop,
            };
        });
        saveEditedStopProducts(modifiedStopsPayload);
    };
    
    return (
        <Box className={classes.root}>
            <Box className={classes.header}>
                <IconButton onClick={onBack} edge="start" className={classes.backButton}>
                    <ArrowBackIcon/>
                </IconButton>
                <Box>
                    <Typography variant="h6" className={classes.headerTitle}>
                        {tour.vehicleLicensePlate || `Tour #${tour.tourId}`}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        {tour.stops.length} {t('stops')} • {tour.microHubName}
                    </Typography>
                </Box>
            </Box>

            <Box className={classes.listContainer}>
                <List disablePadding>
                    {sortedStops.map((stop) => {
                        const boxTypesForShipper = boxTypesAllShipper[stop.shipperName] || [];

                        return (
                           <TourStopCard
                               key={stop.tourStopId}
                               stop={stop}
                               color={tour.color}
                               boxTypes={boxTypesForShipper}
                               editedStops={editedStops}
                               onAmountChange={handleAmountChange}
                           />
                        );
                    })}
                </List>
                <Box p={2} mt={2} mb={2}>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={handleSave}
                        disabled={Object.keys(editedStops).length === 0}
                    >
                        {t('save')}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

DriverTourDetail.propTypes = {
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    tour: PropTypes.object,
    saveEditedStopProducts: PropTypes.func.isRequired,
    boxTypesAllShipper: PropTypes.object.isRequired,
    onBack: PropTypes.func.isRequired,
};

export default compose(withStyles(styles), withTranslation())(DriverTourDetail);